<button #open class="btn btn-link" (click)="openDialog()">
  {{ 'anonymousConsents.preferences' | cxTranslate }}
</button>
